module.exports = __webpack_public_path__ + "static/img/nukied.bb67a49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/nukied.jpg
// module id = 5lMG
// module chunks = 0